var map = {
	"./1/1.png": 8132,
	"./1/2.png": 719,
	"./1/3.png": 1231,
	"./1/4.png": 177,
	"./2/1.png": 9179,
	"./2/2.png": 4653,
	"./2/3.png": 404,
	"./2/4.png": 3238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3801;